const c = {
  name: "Heater",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19,6V0h-2v6H19z"/>
		<path class="st0" d="M18,38.3c-0.8,1-2.1,1.7-3.5,1.7c-2.3,0-4.2-1.8-4.5-4H8c-0.5,0-1,0.5-1,1v3H5v-3c0-1.7,1.3-3,3-3h2V15H8v3H4
			c-2.2,0-4-1.8-4-4s1.8-4,4-4h4v3h2v-0.5C10,10,12,8,14.5,8c1.4,0,2.7,0.7,3.5,1.7c0.8-1,2.1-1.7,3.5-1.7c1.4,0,2.7,0.7,3.5,1.7
			c0.8-1,2.1-1.7,3.5-1.7c1.4,0,2.7,0.7,3.5,1.7c0.8-1,2.1-1.7,3.5-1.7C38,8,40,10,40,12.5v23c0,2.5-2,4.5-4.5,4.5
			c-1.4,0-2.7-0.7-3.5-1.7c-0.8,1-2.1,1.7-3.5,1.7c-1.4,0-2.7-0.7-3.5-1.7c-0.8,1-2.1,1.7-3.5,1.7C20.1,40,18.8,39.3,18,38.3z
			 M12,12.5v23c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-23c0-1.4-1.1-2.5-2.5-2.5S12,11.1,12,12.5z M31,35.5v-23
			c0-1.4-1.1-2.5-2.5-2.5c-1.4,0-2.5,1.1-2.5,2.5v23c0,1.4,1.1,2.5,2.5,2.5C29.9,38,31,36.9,31,35.5z M33,12.5v23
			c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-23c0-1.4-1.1-2.5-2.5-2.5S33,11.1,33,12.5z M21.5,10c-1.4,0-2.5,1.1-2.5,2.5v23
			c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5v-23C24,11.1,22.9,10,21.5,10z M2,14c0,1.1,0.9,2,2,2h2v-4H4C2.9,12,2,12.9,2,14z"/>
		<path class="st0" d="M26,0v6h-2V0H26z"/>
		<path class="st0" d="M33,6V0h-2v6H33z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Heater
};
